import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

import { resetContainerPaddings } from "utils/styles";

const heroStyles = {
  wrapper: (): SystemStyleObject<Theme> => ({
    mx: resetContainerPaddings,
  }),
  background: (theme: Theme): SystemStyleObject<Theme> => ({
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/background.png)`,
    position: "relative",
    backgroundSize: "cover",
    overflowY: "hidden",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "&::before": {
      content: "''",
      position: "absolute",
      zIndex: 1,
      width: "100%",
      left: 0,
      height: "20%",
      pointerEvents: "none",
      bottom: 0,
      backgroundImage: `linear-gradient(0deg, ${theme.palette.background.default}, transparent)`,
    },
  }),
  tagWrapper: (): SystemStyleObject<Theme> => ({
    position: "relative",
    width: "30%",
    maxWidth: 300,

    "&::after": {
      content: "''",
      position: "absolute",
      width: "60%",
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%",
      pointerEvents: "none",
      bottom: 0,
      background: "#FFF",
      opacity: 0.25,
      filter: "blur(122px)",
      zIndex: 10,
    },
  }),
  heading: (): SystemStyleObject<Theme> => ({
    fontSize: { xs: 70, sm: 110, md: 140, lg: 200, xl: 220 },
    mt: { xs: 16, sm: 20, md: 22, lg: 24, xl: 28 },
    textTransform: "uppercase",
    fontWeight: 800,
    textAlign: "center",
    lineHeight: 1,

    backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)`,
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
  }),
  container: (): SystemStyleObject<Theme> => ({
    display: "grid",
    width: "100%",
    height: "100%",
    zIndex: 30,
    mt: { xs: "-26vw", sm: -20, md: -20, lg: -20, xl: -25 },
  }),
  itemBox: (): SystemStyleObject<Theme> => ({
    display: "grid",
    alignContent: "center",
    gridColumn: 1,
    gridRow: 1,
  }),
  item: (): SystemStyleObject<Theme> => ({
    display: "grid",
    position: "relative",
  }),
  text: (theme: Theme): SystemStyleObject<Theme> => ({
    textTransform: "uppercase",
    lineHeight: 1.3,
    fontWeight: 800,
    textAlign: "center",
    color: theme.palette.secondary.main,
    alignSelf: "center",

    WebkitTextStrokeColor: theme.palette.secondary.main,
    textStrokeColor: theme.palette.secondary.main,

    WebkitTextStrokeWidth: { xs: 1, md: 2 },
    textStrokeWidth: { xs: 1, md: 2 },
  }),
  tshirt: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    left: { xs: 0, md: 80, lg: 100, xl: 120 },
    top: { xs: "calc(50% + 20px)", md: "50%" },
    maxWidth: { xs: 180, md: 250, lg: 320, xl: 340 },

    transform: "translateY(-50%)",
    animation: `levitating-top 6s ${theme.transitions.easing.easeInOut} -1s infinite`,

    "@keyframes levitating-top": {
      "0%": {
        transform: "translateY(-55%)",
      },
      "50%": {
        transform: "translateY(-45%)",
      },
      "100%": {
        transform: "translateY(-55%)",
      },
    },
  }),
  shoe: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",

    right: { xs: 0, md: 80, lg: 100, xl: 120 },
    top: { xs: "50%", md: "50%" },
    maxWidth: { xs: 180, md: 250, lg: 320, xl: 340 },

    transform: "translateY(-50%)",
    animation: `levitating-bottom 6s ${theme.transitions.easing.easeInOut} -1s infinite`,

    "@keyframes levitating-bottom": {
      "0%": {
        transform: "translateY(-45%)",
      },
      "50%": {
        transform: "translateY(-55%)",
      },
      "100%": {
        transform: "translateY(-45%)",
      },
    },
  }),
  strokeText: (theme: Theme): SystemStyleObject<Theme> => ({
    color: "transparent",

    WebkitTextStrokeColor: theme.palette.secondary.main,
    textStrokeColor: theme.palette.secondary.main,

    position: "relative",

    WebkitTextStrokeWidth: { xs: 1, md: 2 },
    textStrokeWidth: { xs: 1, md: 2 },
  }),
};

export default heroStyles;
